import { lazy } from 'react';

export const KycMasterPlayerForm = lazy(() => import('./KycMasterPlayerForm'));
